export const getNextSequenceNumber = (roomNames?: string[]): number => {
  let allNumbers: number[] = [];

  if (roomNames && roomNames?.length > 0) {
    roomNames.forEach((str) => {
      const foundNumbers = str.match(/\d+/g);

      if (foundNumbers) {
        allNumbers = allNumbers.concat(foundNumbers.map(Number));
      }
    });
  }

  if (allNumbers.length === 0) {
    return 1;
  }

  const largestNumber = Math.max(...allNumbers);

  return largestNumber + 1;
};
